import React from 'react';
import { Search, X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

/**
 * Search input that either reports every keystroke (mode AUTO) or only on Enter / the Search button
 * (mode SUBMIT). `value` is what is typed; `onSubmit` receives the term to search for.
 */
const SearchBar = ({
  value,
  onChange,
  onSubmit,
  mode = 'AUTO',
  placeholder = 'Search…',
  onKeyDown,
  autoFocus = false,
  className = '',
  inputRef,
}) => {
  const submitMode = mode === 'SUBMIT';
  const submit = () => onSubmit?.(value.trim());

  return (
    <form
      role="search"
      className={`flex w-full items-stretch gap-2 ${className}`}
      onSubmit={(e) => {
        e.preventDefault();
        if (submitMode) submit();
      }}
    >
      <div className="relative flex-1 min-w-0">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 pointer-events-none" />
        <Input
          ref={inputRef}
          type="search"
          enterKeyHint="search"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={onKeyDown}
          className={`pl-10 ${submitMode && value ? 'pr-9' : ''}`}
          autoFocus={autoFocus}
          autoComplete="off"
        />
        {submitMode && value && (
          <button
            type="button"
            onClick={() => {
              onChange('');
              onSubmit?.('');
            }}
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-gray-400 hover:text-gray-600"
            aria-label="Clear search"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      {submitMode && (
        <Button type="submit" className="shrink-0">
          <Search className="w-4 h-4 sm:mr-2" />
          <span className="hidden sm:inline">Search</span>
        </Button>
      )}
    </form>
  );
};

export default SearchBar;
